import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core';
import type { ShareState } from 'domain/permission/types';
import type { ShareModel } from '../share-model';


function createEmptyState(): ShareState {
    return {
        isShareModel: true,
    };
}

@injectable()
export class ShareModelImpl extends AbstractModel<ShareState> implements ShareModel {
    protected _modelData: ShareState = createEmptyState();
}
